export type MapWithDefault<T> = { get: (key: string) => T };

export function mapWithDefault<K extends string, T>({
  map,
  defaultValue,
}: {
  map: Record<K, T>;
  defaultValue: T;
}): MapWithDefault<T> {
  return {
    get: (key: string) => (key in map ? map[key as K] : defaultValue),
  };
}

export function mapWithDefaultProvider<K extends string, T>({
  map,
  defaultProvider,
}: {
  map: Record<K, T>;
  defaultProvider: (key: string) => T;
}): MapWithDefault<T> {
  return {
    get: (key: string) => (key in map ? map[key as K] : defaultProvider(key)),
  };
}
